import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";

const CashbackSupport = loadable(() => import("./CashbackSupport"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <CashbackSupport {...props} />
  </ErrorBoundary>
);
